@if(hasNoProducts){
<app-banner-message></app-banner-message>
}

@if (user().organizationType == 'MULTI') {
<app-peer-comparison-multi [hasBothProducts]="hasBothProducts" [hasNonMaturity]="hasNonMaturity"
    [hasPeerComparison]="hasPeerComparison" [hasNoProducts]="hasNoProducts"></app-peer-comparison-multi>


} @else {

@if(hasPeerComparison || hasNoProducts){
<app-peer-comparison-institution [hasBothProducts]="hasBothProducts" [hasNonMaturity]="hasNonMaturity"
    [hasPeerComparison]="hasPeerComparison" [hasNoProducts]="hasNoProducts"></app-peer-comparison-institution>
}

@if(hasNonMaturity){
<app-peer-comparison-multi [hasBothProducts]="hasBothProducts" [hasNonMaturity]="hasNonMaturity"
    [hasPeerComparison]="hasPeerComparison" [isBank]="true" [hasNoProducts]="hasNoProducts"></app-peer-comparison-multi>
}

}